import React, { useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getResetPassword } from "../../../service/AuthenticationService";
import instance from "../../../WebApi/WebApi";

const ChangePassword = (props) => {
  const navigate = useNavigate();

  const { logo } = props;
  const [showOldpassword, setShowOldPassword] = useState(false);
  const [showpassword, setShowPassword] = useState(false);
  const [showConfirmpassword, setShowConfirmPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      oldpassword: "",
      password: "",
      confirmpassword: "",
    },
    validationSchema: yup.object({
      oldpassword: yup
        .string()

        .required("Old Password is required"),
      password: yup
        .string()
        .min(8, "Password must have atleast 8 chracter")
        .required("Password is required"),
      confirmpassword: yup
        .string()
        .oneOf([yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (values) => {
      // console.log(values);
      const data = {
        oldPassword: values?.oldpassword,
        newPassword: values?.password,
      };

      try {
        const response = await instance.post(`/user/change-password`, data);
        if (response?.data?.success === true) {
          toast.success(response?.data?.message);
          navigate("/dashboard");
        } else {
          toast.error(response?.data?.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      }
    },
  });

  const renderOldPasswordError = formik.touched.oldpassword &&
    formik.errors.oldpassword && (
      <span className="errorTxt">{formik.errors.oldpassword}</span>
    );
  const renderPasswordError = formik.touched.password &&
    formik.errors.password && (
      <span className="errorTxt">{formik.errors.password}</span>
    );

  const renderConfirmPasswordError = formik.touched.confirmpassword &&
    formik.errors.confirmpassword && (
      <span className="errorTxt">{formik.errors.confirmpassword}</span>
    );

  return (
    <>
      <div className="loginBg">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-6 centerResp">
              <span className="logo">
                <img src={logo} alt="" />
              </span>
              <h2>Welcome!</h2>
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration.
              </p>
            </div> */}
            <div className="col-lg-12">
              <div className="loginBase">
                <div className="text-center">
                  <h3>Change Password</h3>
                  <h6 className="mb-5">
                    Enter your new password. (Enter minimum 8 characters)
                  </h6>
                </div>

                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-4">
                    <div className="showHide">
                      <input
                        className="form-control"
                        name="oldpassword"
                        type={showOldpassword ? "text" : "password"}
                        id="password"
                        placeholder="Old Password"
                        onChange={formik.handleChange}
                        value={formik.values.oldpassword}
                      />
                      <div
                        className="input-group-addon eyeAbs"
                        onClick={() => {
                          setShowOldPassword(!showOldpassword);
                        }}
                      >
                        <span>
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        </span>
                      </div>
                      {renderOldPasswordError}
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="showHide">
                      <input
                        className="form-control"
                        name="password"
                        type={showpassword ? "text" : "password"}
                        id="password"
                        placeholder="New Password"
                        onChange={formik.handleChange}
                        value={formik.values.password}
                      />
                      <div
                        className="input-group-addon eyeAbs"
                        onClick={() => {
                          setShowPassword(!showpassword);
                        }}
                      >
                        <span>
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        </span>
                      </div>
                      {renderPasswordError}
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="showHide">
                      <input
                        className="form-control"
                        name="confirmpassword"
                        type={showConfirmpassword ? "text" : "password"}
                        id="confirmpassword"
                        placeholder="Confirm Password"
                        onChange={formik.handleChange}
                        value={formik.values.confirmpassword}
                      />
                      <div
                        className="input-group-addon eyeAbs"
                        onClick={() => {
                          setShowConfirmPassword(!showConfirmpassword);
                        }}
                      >
                        <span>
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        </span>
                      </div>
                      {renderConfirmPasswordError}
                    </div>
                  </div>

                  <div className="loginBtn pt-3 mb-5">
                    <button type="submit" className="commonButton">
                      Change Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
